import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ComponentReviewThreadSchema = withDefaults({
  type: 'component-review-thread',
  objectExtensions: ['component-review-thread'],
  fields: [
    {
      kind: 'attribute',
      name: 'reviewId',
    },
    {
      kind: 'attribute',
      name: 'pagePath',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'screenshotUrl',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'createdBy',
      type: 'person',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'comments',
      type: 'component-review-comment',
      options: {
        async: false,
        inverse: 'thread',
      },
    },
  ],
});

export default ComponentReviewThreadSchema;
